import { generateGUID } from "@/utils/guid";
import { FormItem } from "@psychlab/types/form";

export const duplicateFormItem = (item:FormItem<any>):FormItem<any> => {
	const copy = JSON.parse(JSON.stringify(item));
	copy.id = generateGUID();
	// copy.name = copy.name && copy.name.length > 0 ? copy.name : copy.type;
	copy.name = copy.name || "";
	return copy;
};